// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.radio-container[data-v-45b9f6ae] {\n  display: flex;\n  flex-wrap: wrap;\n  /* 允许项目换行 */\n}\n.radio-container .el-radio[data-v-45b9f6ae] {\n  margin-right: 20px;\n  /* 根据需要调整间距 */\n  margin-bottom: 10px;\n  /* 根据需要调整间距 */\n}", ""]);
// Exports
module.exports = exports;
